import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const trashProjectsDirectoryRoute: InvariantJiraRoute = {
	name: 'trash-projects-directory',
	path: '/jira/settings/projects/trash',
	exact: true,
};
